// =============================================================================
// BushWear cart nudge - free-delivery progress + "add this" (cart page + drawer)
// 11 Oct 2026. Markup: snippets/cart-nudge.liquid. Styles: custom.css.liquid.
//
// Both the cart drawer and the cart page rebuild their line items from
// templates/cart.ajax.liquid, which carries a freshly rendered nudge inside
// <template data-cart-nudge-src>. After every rebuild we copy it into the
// form's [data-cart-nudge-slot], so the gap is always worked out server-side.
//
// Adding the suggested item:
//   cart page -> reload /cart (as before), so Order Deadline dates the new line
//   drawer    -> rebuild the drawer, then re-run the Order Deadline drawer init
//                (drawerOpen) so the new line gets its delivery date too.
// =============================================================================
(function () {
  if (window.__bwCartNudge) { return; }
  window.__bwCartNudge = true;

  var FORMS = ['CartDrawerForm', 'CartPageForm'];
  var lastShown = {};

  function push(o) { if (window.dataLayer) { window.dataLayer.push(o); } }
  function where(el) { return el.closest('#CartDrawerForm') ? 'drawer' : 'cart'; }

  // One impression per distinct nudge per place - not one per drawer rebuild
  function announce(slot) {
    var loc = where(slot);
    var won = slot.querySelector('[data-cart-nudge-unlocked]');
    var el = slot.querySelector('[data-cart-nudge]');
    var key = won ? 'unlocked' : (el ? el.getAttribute('data-variant-id') : '');
    if (key && lastShown[loc] !== key) {
      if (won) { push({ event: 'cart_nudge_qualified', location: loc }); }
      else { push({ event: 'cart_nudge_shown', variant_id: key, location: loc }); }
    }
    lastShown[loc] = key;
  }

  function sync(form) {
    var slot = form.querySelector('[data-cart-nudge-slot]');
    var src = form.querySelector('[data-products] template[data-cart-nudge-src]');
    if (!slot || !src) { return; }
    slot.innerHTML = src.innerHTML;
    announce(slot);
  }

  function watch(form) {
    var products = form.querySelector('[data-products]');
    if (!products) { return; }
    new MutationObserver(function () { sync(form); }).observe(products, { childList: true });
    var slot = form.querySelector('[data-cart-nudge-slot]');
    if (products.querySelector('template[data-cart-nudge-src]')) { sync(form); }
    else if (slot) { announce(slot); }
  }

  function init() {
    FORMS.forEach(function (id) {
      var form = document.getElementById(id);
      if (form) { watch(form); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cart-nudge-add]');
    if (!btn) { return; }
    e.preventDefault();
    var el = btn.closest('[data-cart-nudge]');
    if (!el || btn.disabled) { return; }

    var loc = where(el);
    var variantId = el.getAttribute('data-variant-id');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    push({ event: 'cart_nudge_accepted', sku: el.getAttribute('data-sku'), variant_id: variantId, location: loc });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('add failed: ' + r.status); }
        if (loc === 'cart') {
          var cartUrl = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
          window.location.href = cartUrl;
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('drawerOpen'));
      })
      .catch(function (err) {
        console.error('[cart-nudge]', err);
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();
